import { render } from "./OrderedMerchItem.vue?vue&type=template&id=79cac46c&scoped=true"
import script from "./OrderedMerchItem.vue?vue&type=script&lang=js"
export * from "./OrderedMerchItem.vue?vue&type=script&lang=js"

import "./OrderedMerchItem.vue?vue&type=style&index=0&id=79cac46c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79cac46c"]])

export default __exports__